import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Drawer } from '~/components/Drawers'
import FilterReviewsForm from '~/components/Filters/Reviews/Form'

export function FilterReviewsDrawer({ open, onClose }) {
  return (
    <>
      <Drawer open={open} onClose={onClose}>
        <Drawer.Header>
          <Drawer.Header.Title>
            <FormattedMessage id={'Filters'} />
          </Drawer.Header.Title>
          <Drawer.Header.Close />
        </Drawer.Header>
        {open && <FilterReviewsForm onClose={onClose} />}
      </Drawer>
    </>
  )
}
